import React, { useContext, Fragment, SetStateAction, Dispatch } from 'react';
import { FormattedMessage } from 'react-intl';
import { Dialog, Transition } from '@headlessui/react';
import { PrecheckContext } from '../contexts/PrecheckContext';
import { updateDriver } from '../services/APIs';
import { updateLanguagePreference } from '../services/APIs';

interface LanguageDialogProps {
    isLanguageDialogOpen: boolean;
    setIsLanguageDialogOpen: Dispatch<SetStateAction<boolean>>;
    selectedLanguage: 'en' | 'es' | 'ru';
    setSelectedLanguage: React.Dispatch<SetStateAction<'en' | 'es' | 'ru'>>;
}

const LanguageDialog = ({
    isLanguageDialogOpen,
    setIsLanguageDialogOpen,
    selectedLanguage,
    setSelectedLanguage
}: LanguageDialogProps) => {
    const ref = React.useRef<HTMLDivElement>(null);

    const { precheckInfo, setPrecheckInfo } = useContext(PrecheckContext);

    const handleClose = () => {
        setPrecheckInfo({ ...precheckInfo, language: selectedLanguage });
        updateLanguagePreference(precheckInfo.driverId, selectedLanguage);

        setIsLanguageDialogOpen(false);
    };

    return (
        <Transition appear show={isLanguageDialogOpen} as={Fragment} ref={ref}>
            <Dialog as="div" className="" onClose={() => setIsLanguageDialogOpen(false)}>
                <Transition.Child
                    as={Fragment}
                    enter="ease-out duration-300"
                    enterFrom="opacity-0"
                    enterTo="opacity-100"
                    leave="ease-in duration-200"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0">
                    <div className="" />
                </Transition.Child>

                <div className="">
                    <div
                        className="text-center py-5 position-absolute top-0"
                        style={{
                            height: '100vh',
                            width: '100%',
                            background:
                                'linear-gradient(0deg, rgba(255,255,255,0.4) 22%, rgba(0,95,175,0.5) 100%)',
                            backdropFilter: 'blur(10px)',
                            WebkitBackdropFilter: 'blur(10px)'
                        }}>
                        <Transition.Child
                            as={Fragment}
                            enter="ease-out duration-300"
                            enterFrom="opacity-0 scale-95"
                            enterTo="opacity-100 scale-100"
                            leave="ease-in duration-200"
                            leaveFrom="opacity-100 scale-100"
                            leaveTo="opacity-0 scale-95">
                            <Dialog.Panel className="h-100">
                                <Dialog.Title
                                    as="h3"
                                    className="text-white"
                                    style={{ userSelect: 'none' }}>
                                    <FormattedMessage
                                        id="languageDialogTitle"
                                        defaultMessage="Select Language"
                                    />
                                </Dialog.Title>

                                <div className="rounded   m-5">
                                    <div
                                        onClick={() => setSelectedLanguage('en')}
                                        style={{ userSelect: 'none' }}
                                        className={`py-3 rounded text-white ${
                                            selectedLanguage === 'en'
                                                ? 'bg-primary-color '
                                                : 'bg-clear'
                                        }`}>
                                        English
                                    </div>
                                    <div
                                        className={`py-3 rounded text-white ${
                                            selectedLanguage === 'es'
                                                ? 'bg-primary-color '
                                                : 'bg-clear'
                                        }`}
                                        style={{ userSelect: 'none' }}
                                        onClick={() => setSelectedLanguage('es')}>
                                        Español
                                    </div>
                                    <div
                                        className={`py-3 rounded text-white ${
                                            selectedLanguage === 'ru'
                                                ? 'bg-primary-color '
                                                : 'bg-clear'
                                        }`}
                                        style={{ userSelect: 'none' }}
                                        onClick={() => setSelectedLanguage('ru')}>
                                        Русский
                                    </div>
                                </div>
                                <div className="mt-2 d-flex w-100 justify-content-center">
                                    <button
                                        type="button"
                                        style={{ userSelect: 'none' }}
                                        className="btn bg-dark text-white w-50"
                                        onClick={handleClose}>
                                        <FormattedMessage id="confirm" defaultMessage="Confirm" />
                                    </button>
                                </div>
                            </Dialog.Panel>
                        </Transition.Child>
                    </div>
                </div>
            </Dialog>
        </Transition>
    );
};

export default LanguageDialog;
